import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import classes from "./SubscriptionPage.module.css";
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import SmallLoader from '../components/Loaders/SmallLoader';
import OTPInput from "react-otp-input";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FaCheck } from "react-icons/fa";
// import { getPacks } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
import { SendOtpAPI } from '../http/http';
import { setUserToken } from '../store/slices/userTokenSlice';
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';
import { motion } from "motion/react"
import AutoRenewalModal from '../components/AutoRenewalModal';
import TermsModal from '../components/Termsmodal';
import SubLayout from '../components/SubLayout';

const SubscriptionPage = () => {
    const { t } = useTranslation();
    const [msisdn, setMsisdn] = useState("");
    const [loading, setLoading] = useState(false);
    const [extRef, setExtRef] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();

    const [termsModal, setTermsModal] = useState(false);

    // const [autoRenewal, setAutoRenewal] = useState(false);
    const [autoRenewal, setAutoRenewal] = useState(true);

    const toggleSwitch = () => setAutoRenewal(!autoRenewal)

    const [modal, setModal] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { userToken } = useSelector(state => state.persisted.userTokenSlice);

    useEffect(() => {
        if (userToken) {
            navigate("/home");
        }
    }, [userToken]);

    useEffect(() => {
        if (searchParams.get("ext_ref")) {
            setExtRef(searchParams.get("ext_ref"));
        } else {
            setSearchParams({ ext_ref: uuidv4() });
        }
    }, [searchParams]);

    const handleFormSubmission = async (e) => {
        e.preventDefault();

        try {
            if (msisdn?.trim().length == 0) {
                return;
            }
            setLoading(true);

            const response = await SendOtpAPI(msisdn);
            setLoading(false);
            if (response?.data?.status == 1) {
                navigate("/otp", {
                    state: {
                        msisdn: msisdn,
                        extRef: extRef,
                        autoRenewal: autoRenewal
                    }
                })
            }
            else if (response?.data?.status == 2) {
                navigate("/postpaid-issue", {
                    state: {
                        msisdn: msisdn,
                        extRef: extRef,
                        autoRenewal: autoRenewal
                    }
                })
            }
            else {
                toast.error(t("94"));
            }
        } catch (error) {
            setLoading(false);
            if (error?.response?.data?.status == 3) {
                toast.error(t("110"));
            }
            else {
                toast.error(t("86"));
            }
        }
    }

    return (
        <>
            <Header />

            <SubLayout>

            {/* <div className={classes.container}> */}
                <h1 className={classes.heading}>
                    <span style={{ color: '#e63946' }}>Quiz Masters</span>{" "}{t("59")}
                </h1>
                <div className={classes.actions_box_container}>
                    <div className={classes.actions_box}>
                        <button className={`${classes.action_box}`}
                            type='button'
                            onClick={() => navigate(`/login?ext_ref=${extRef}`)}>
                            {t("60")}
                        </button>
                        <button className={`${classes.action_box} ${classes.active}`}>
                            {t("61")}
                        </button>
                    </div>
                </div>


                <form className={classes.form} onSubmit={handleFormSubmission}
                >
                    <div className={classes.username_field_form}>
                        <div className={classes.country_code}>
                            <img src="/assets/images/equatorial-guinea.png" alt="flag" className={classes.flag} />
                            <p className={classes.country_code_number}>+240</p>
                        </div>
                        <input
                            id="msisdn"
                            name="msisdn"
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            autoFocus placeholder={t("62")} className={classes.input_field_username}
                            onChange={(e) => {
                                setMsisdn(e.target.value)
                            }}
                            value={msisdn}
                        />
                    </div>

                    <div className={classes.packs}>
                        <p className={classes.packs_heading}>{t("63")}</p>

                        <button type='button' className={`${classes.pack_box} ${classes.shade_blue}`}
                        >
                            <span className={`${classes.pack_header}`}>{t("64")}</span>
                            <div className={`${classes.checked_radio} ${classes.shade_blue}`}>
                                <FaCheck className={classes.checked_icon} />
                            </div>
                            <p className={`${classes.pack_price_point} ${classes.active}`}>
                                {t("65")}{" "}/{" "}
                                {t("66")}
                            </p>
                        </button>
                    </div>

                    <div className={classes.check_box_container}>
                        <input type="checkbox" id="terms" name="Terms & Conditions" value="Terms"
                            className={classes.check_box} checked
                        >
                        </input>
                        <label for="terms" className={classes.check_box_label}>
                            {t("99")}{" "}<span className={classes.link} onClick={() => setTermsModal(true)}>{t("100")}</span>
                        </label>
                    </div>

                    <div className={classes.auto_renewal_container}>
                        <input type="checkbox" id="autoRenewal" name="Auto Renewal" value="Auto Renewal"
                            className={classes.check_box} checked={autoRenewal} onClick={toggleSwitch}
                        >
                        </input>
                        <label for="terms" className={classes.check_box_label}>
                            <span className={classes.link} onClick={() => setModal(true)}>{t("101")}</span>
                        </label>
                    </div>

                    <button type="submit"
                        disabled={loading}
                        className={classes.login_btn}>{
                            loading ? <SmallLoader style={{ border: "5px solid #fff" }} /> : t("61")
                        }</button>
                    <div className={classes.footer}>
                        <p><span>&copy;</span> Rainboo Softmate {new Date().getFullYear()}</p>
                    </div>
                </form>

            {/* </div> */}

            </SubLayout>

            {modal && <AutoRenewalModal setModal={setModal} />}
            {termsModal && <TermsModal setTermsModal={setTermsModal} />}
        </>
    )
}

export default SubscriptionPage;